import Swiper, { Navigation } from 'swiper'

const swiperNews = new Swiper('.news-slider__swiper', {
  loop: true,
  slidesPerView: 1.2,
  modules: [
    Navigation,
  ],

  navigation: {
    nextEl: '.news-slider__next',
    prevEl: '.news-slider__prev',
  },

  breakpoints: {
    1400: {
      slidesPerView: 3,
    },
    960: {
      slidesPerView: 2,
    },
    700: {
      slidesPerView: 1.4,
    },
  },

  spaceBetween: 20,
})
